module.exports = __webpack_public_path__ + "img/crops.b6ea26cd.png";